import { Outlet, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'
import { PWAInstallPrompt } from './components/custom/pwa-install-prompt'
import { useAuthInit, useTokenRefresh } from './features/auth/hooks'
import { usePWA } from './hooks'
import { useAuthStore } from './features/auth/store/authStore'

function App() {
  const router = useRouter()

  useEffect(() => {
    const navigateTo = (to: string) => router.navigate({ to })
    useAuthStore.getState().setNavigation(navigateTo)
  }, [router])

  useAuthInit()
  useTokenRefresh()
  usePWA()

  return (
    <>
      <Outlet />
      <PWAInstallPrompt />
    </>
  )
}

export default App
